module.exports = __webpack_public_path__ + "static/img/p1.7bb37e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robot/LMD1/p1.png
// module id = 2o6B
// module chunks = 7